import styled from '@emotion/styled';

export const FieldError = styled.div`
  min-height: 16px;
  color: var(--colorUIRed);
  font-size: 12px;
  margin-top: 4px;
`;
